
<template>
  <el-tabs type="border-card" style="height:100%">
    <el-tab-pane label="配置">
      <el-form v-if="selectSvgInfo.typeName" label-width="60px" :model="selectSvgInfo" size="mini">
        <el-form-item label="ID">
          <el-input v-model="svgInfo.id" disabled placeholder="请选择一个节点" />
        </el-form-item>
        <el-form-item label="类型">
          <el-input v-model="selectSvgInfo.typeName" disabled placeholder="请选择一个节点" />
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="selectSvgInfo.title" placeholder="请输入组件名称" />
        </el-form-item>
        <el-form-item label="关联设备">
            <el-cascader
              :props="props"
              clearable
              v-model="selectDevice"
              @change="deviceChange"
              :options="devices"
           ></el-cascader>
        </el-form-item>
        <el-form-item label="对应属性">
          <el-select v-model="selectSvgInfo.property" placeholder="请选择对应属性">
            <el-option
              v-for="item in propertyList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="X轴坐标">
          <el-input-number v-model="selectSvgInfo.svgPositionX" :min="0" :max="1920" placeholder="请输入Y轴坐标" />
        </el-form-item>
        <el-form-item label="Y轴坐标">
          <el-input-number v-model="selectSvgInfo.svgPositionY" :min="0" :max="1080" placeholder="请输入Y轴坐标" />
        </el-form-item>
        <template v-if="selectSvgInfo.type=='ConnHorizontalLineSvg'">
          <el-form-item label="长度">
            <el-input-number v-model="selectSvgInfo.mPoint.endX" :min="0" :max="5000" placeholder="请输入线条长度" />
          </el-form-item>
        </template>
        <template v-if="selectSvgInfo.type=='ConnVerticalLineSvg'">
          <el-form-item label="高度">
            <el-input-number v-model="selectSvgInfo.mPoint.endY" :min="0" :max="5000" placeholder="请输入线条高度" />
          </el-form-item>
        </template>
        <template v-if="selectSvgInfo.type=='ConnLineSvg'">
          <el-form-item label="宽度">
            <el-input-number v-model="selectSvgInfo.mPoint.endX" :min="0" :max="5000" placeholder="请输入连接线宽度" />
          </el-form-item>
          <el-form-item label="高度">
            <el-input-number v-model="selectSvgInfo.mPoint.endY" :min="0" :max="5000" placeholder="请输入连接线高度" />
          </el-form-item>
        </template>
        <el-form-item label="大小">
          <el-input-number v-model="selectSvgInfo.size" :min="0.5" :max="3000" :precision="1" :step="0.1" />
        </el-form-item>
        <el-form-item label="旋转">
          <el-input-number v-model="selectSvgInfo.angle" :min="0" :max="360" />
        </el-form-item>
        <el-form-item label="颜色">
          <el-color-picker v-model="selectSvgInfo.svgColor" />
        </el-form-item>
        <!-- <el-form-item label="">
          <el-button type="primary" style="" @click="handleSaveConfig">保存配置</el-button>
        </el-form-item> -->
      </el-form>
      <el-alert
        v-if="!selectSvgInfo.typeName"
        title="请先选择一个节点"
        type="warning"
        show-icon
        :closable="false" />
    </el-tab-pane>
    <el-tab-pane label="数据">
      <json-viewer
        :value="svgInfo"
        :expand-depth="5"
        copyable
        sort />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import JsonViewer from 'vue-json-viewer';

export default {
  components: { JsonViewer },
  props: {
    svgInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    devices: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      props: {
        value: 'IdStr',
        label: 'ModelName',
        children: 'Children',
        checkStrictly: true
      },
      selectDevice: [],
      // devices: []
      propertyList: [
        {
          name: '设备名称',
          value: 'device_name'
        },
        {
          name: '正向有功示值',
          value: 'zygsz'
        },
        {
          name: 'A相电流',
          value: 'Ia'
        },
        {
          name: 'B相电流',
          value: 'Ib'
        },
        {
          name: 'C相电流',
          value: 'Ic'
        },
        {
          name: 'A相电压',
          value: 'Ua'
        },
        {
          name: 'B相电压',
          value: 'Ub'
        },
        {
          name: 'C相电压',
          value: 'Uc'
        },
        {
          name: 'A相温度',
          value: 'ta'
        },
        {
          name: 'B相温度',
          value: 'tb'
        },
        {
          name: 'C相温度',
          value: 'tc'
        }
      ]
    }
  },
  computed: {
    selectSvgInfo() {
      return this.svgInfo
    }
  },
  watch: {
    'selectSvgInfo.tableRowCount': function(newVal) {
      this.$emit('setTableAttr', this.selectSvgInfo.id, newVal, this.selectSvgInfo.tableColCount)
    },
    'selectSvgInfo.tableColCount': function(newVal) {
      this.$emit('setTableAttr', this.selectSvgInfo.id, this.selectSvgInfo.tableRowCount, newVal)
    },
    selectSvgInfo: function(val) {
      if (val.id) {
        this.selectDevice = []
        if (val.deviceId) {
          const d = this.devices.find(e => {
            return e.IdStr === val.deviceId
          })
          if (d) {
            this.selectDevice.push(val.deviceId)
          } else {
            for (let i = 0; i < this.devices.length; i++) {
              const byq = this.devices[i].Children.find(e => {
                return e.IdStr === val.deviceId
              })
              console.log(byq)
              if (byq) {
                this.selectDevice.push(this.devices[i].IdStr);
                this.selectDevice.push(val.deviceId)
                break
              }
            }
          }
        }
        if (!val.deviceId) {
          console.log('根据id' + val.id + "拉取节点关联的设备号,填充'selectSvgInfo.deviceId'")
          // val.deviceId = ''
        }
      }
    },
  },
  methods: {
    handleSaveConfig() {
      console.log(this.selectSvgInfo)
    },
    deviceChange(val) {
      this.selectSvgInfo.deviceId = val[val.length - 1]
    }
  }
}
</script>
<style scoped lang="scss">

</style>
